import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './final-component/home/home.component';
import { LoginPageComponent } from './final-component/login-page/login-page.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ContactComponent } from './final-component/contact/contact.component';
import { NewsComponent } from './final-component/news/news.component';
import { AllNewsComponent } from './all-news/all-news.component';
import { NewsDetailsComponent } from './news-details/news-details.component';
import { SpecificTagComponent } from './specific-tag/specific-tag.component';
import { SpecificWritterComponent } from './specific-writter/specific-writter.component';
import { MovieComponent } from './final-component/movie/movie.component';
import { SearchComponent } from './search/search.component';
import { TypeMovieComponent } from './type-movie/type-movie.component';
import { MovieDetailsComponent } from './movie-details/movie-details.component';
import { ScheduleComponent } from './final-component/schedule/schedule.component';

const routes: Routes =
 [
   {path: '', redirectTo: '/home', pathMatch: 'full'} , 
   {path:"home",component:HomeComponent} , 
   {path:'login',component:LoginPageComponent} , 
   {path:'change',component:ChangePasswordComponent},
   {path:'contact',component:ContactComponent} ,
   {path:"schedule/:day",component:ScheduleComponent} ,
   //childerns News 
   {path:'News',component:NewsComponent , children:[
     {path:'allNews',component:AllNewsComponent},
     {path:'NewsDetails/:id',component:NewsDetailsComponent} , 
     {path:'Tag/:name',component:SpecificTagComponent} , 
     {path:"Writter/:writter",component:SpecificWritterComponent}  
    
    ]} , //end of childerns 
    //childerns Movies

    {path:"Movie",component:MovieComponent,children:[
      {path:"Search/:search",component:SearchComponent} , 
      {path:"Type/:type",component:TypeMovieComponent} , 
      {path:"Details/:movieId",component:MovieDetailsComponent}
    ]},//end of childerns 


 ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
